const screens = {
  sm: '768px',
  md: '1024px',
  lg: '1440px',
  xl: '1680px',
  portrait: {
    raw: '(orientation: portrait)',
  },
};

export default screens;
